import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions, PostStatus } from './index';
import { PostCreateBody } from './create';

export type PostUpdateData = {
  success: boolean;
};

export type PostUpdateResponse = PostUpdateData;

export interface PostUpdateBody extends Partial<PostCreateBody> {
  status?: PostStatus;
}

export interface PostUpdatePayload {
  id: string;
  body: PostUpdateBody
}

export const postUpdate = (payload: PostUpdatePayload): Action<PostUpdatePayload> => ({
  type: actions.postUpdateTrigger.toString(),
  payload,
});

export const postUpdateClear = (): Action => ({
  type: actions.postUpdateClear.toString(),
});

export const postUpdateErrorClear = (): Action => ({
  type: actions.postUpdateErrorReset.toString(),
});

export function* postUpdateRequestSaga({ payload }: Action<PostUpdatePayload>) {
  yield put({
    type: actions.postUpdateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.postUpdateError.toString(),
      payload: {
        message: 'PostUpdate: Parameters not passed.',
      },
    });

    return;
  }

  const { id, body } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}posts/${id}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<PostUpdateData, PostUpdateResponse>(
    response,
    actions.postUpdateSuccess.toString(),
    actions.postUpdateError.toString(),
    false,
    (postUpdateData) => postUpdateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.postUpdateTrigger.toString(),
    defaultProcessingSaga(
      postUpdateRequestSaga,
      {
        error: actions.postUpdateError.toString(),
        locationCancel: actions.postUpdateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.postUpdateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.postUpdateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.postUpdateErrorReset.toString(),
    });
  });
}
